module.exports = __webpack_public_path__ + "img/project3_medium.4b31f6d2.jpg";